import React from 'react'
import InputDateUI from './InputDateUI'

// value: comma separated ISO string, e.g. "2024-09-25, 2026-10-26"
const MultiDateInputUI = ({ context, label, help, value, onChange, error }) => {
	const rows = value == null ? [] : value.split(',').map(s => s.trim())
	const emit = list => onChange({ target: { value: list.join(', ') } })

	return (
		<div>
			{rows.map((iso, i) => (
				<div key={i} style={{ display: 'flex', alignItems: 'flex-end', gap: 8 }}>
					<InputDateUI
						context={context}
						name={`propertyValue_${i}`}
						label={i === 0 ? label : ''}
						help={i === 0 ? help : ''}
						selectedDateISO={iso}
						onChange={(newIso) => emit(rows.map((r, j) => (j === i ? (newIso || '') : r)))}
						error={error}
					/>
					<button type='button' onClick={() => emit(rows.filter((_, j) => j !== i))}>Remove</button>
				</div>
			))}
			<button type='button' onClick={() => emit([...rows, ''])}>+ Add date</button>
		</div>
	)
}

export default MultiDateInputUI